import React, { useEffect, useState } from "react";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import { Link, useLocation, useNavigate } from "react-router-dom";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { trackEvent } from "../Utility/Utility";
import BackSections from "../Giftcards/BackSections";

const PaymentFailed = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const translation = getTranslationData();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleRetry = () => {
    navigate(-1);
  };
  useEffect(() => {
    trackEvent("page_browse", {
      page_title: "Order Failed",
      page_url: window.location.href,
    });
  }, []);
  return (
    <>
      <ScrollToTop />
      <div className="bg-light-grey1">
        <section className="hide-payment-header">
          <BackSections />
        </section>
        <section className={`my-1 mx-1 ${isMobile ? "" : "mt-4"}`}>
          <div className="container p-2 payment-failed-card">
            <div className="bg-wh">
              <div className="row">
                <div className="col-lg-12 col-12 mr-10 payment-failed-container">
                  <div className="warning-sz warning-color">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                    >
                      <defs>
                        <mask id="warningMask">
                          <rect width="40" height="40" fill="white" />
                          <rect
                            x="18"
                            y="10"
                            width="4"
                            height="12"
                            rx="2"
                            fill="black"
                          />
                          <circle cx="20" cy="28" r="2" fill="black" />
                        </mask>
                      </defs>

                      <path
                        d="M29.414 0.586002C29.2286 0.399917 29.0082 0.252341 28.7655 0.151771C28.5229 0.0512003 28.2627 -0.000378898 28 0H12C11.7373 0 11.4771 0.0512003 11.2345 0.151771C10.9918 0.252341 10.7714 0.399917 10.586 0.586002L0.586002 10.586C0.399917 10.7714 0.252341 10.9918 0.151771 11.2345C0.0512003 11.4771 0 11.7373 0 12V28C0 28.532 0.21 29.04 0.586002 29.414L10.586 39.414C10.7714 39.6001 10.9918 39.7477 11.2345 39.8482C11.4771 39.9488 11.7373 40 12 40H28C28.532 40 29.04 39.79 29.414 39.414L39.414 29.414C39.6001 29.2286 39.7477 29.0082 39.8482 28.7655C39.9488 28.5229 40 28.2627 40 28V12C40 11.7373 39.9488 11.4771 39.8482 11.2345C39.7477 10.9918 39.6001 10.7714 39.414 10.586L29.414 0.586002Z"
                        fill="var(--warning-bg)"
                        mask="url(#warningMask)"
                      />
                    </svg>
                  </div>
                  <div className="payment-message">
                    <h3>{translation?.paymentFailed}</h3>
                    <p className="font-p mt-3">
                      <span className="default-client-text">
                        {translation?.yourPaymentFor}{" "}
                        {`'${location?.state?.productReducerDisocount?.name}'`}{" "}
                        {translation?.couldNotBeProcessed}
                      </span>

                      <span className="client2-text">
                        {translation?.payment_failed_purchase}
                      </span>
                    </p>
                  </div>
                </div>
                <span className="line-border"></span>
                <div className="payment-actions">
                  <Link to="/contact-us">
                    <button className="contact-support">
                      {translation?.contactSupport}
                    </button>
                  </Link>
                  {/* <img src={retry} alt="retry" onClick={handleRetry} /> */}
                  <button className="retry-button" onClick={handleRetry}>
                    {translation?.retryPayment}
                  </button>
                </div>
              </div>
            </div>
            <div className="back-home-container">
              <Link to="/" className="back-home-link">
                {translation?.backToHomepage}
              </Link>
            </div>
          </div>
        </section>
        {/* {isMobile && (
          <section className="py-xl-4 pb-4 pt-2">
            <div className="container">
              <div className="row justify-content-center hero">
                <div className="col-lg-8">
                  {isMobile ? (
                    <Carousel>
                      {images.map((image, index) => (
                        <Carousel.Item key={index}>
                          <img
                            className="d-block w-100"
                            src={image.src}
                            alt={image.alt}
                          />
                        </Carousel.Item>
                      ))}
                    </Carousel>
                  ) : (
                    <div className="d-flex justify-content-between">
                      {images.map((image, index) => (
                        <div key={index} className="col-6 p-1">
                          <img
                            className="d-block w-100"
                            src={image.src}
                            alt={image.alt}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        )} */}
      </div>
    </>
  );
};

export default PaymentFailed;
